/** Base URL for the API (no trailing slash). Empty = same origin (use Vite dev proxy). */
export function getApiBase(): string {
  const raw = import.meta.env.VITE_API_URL;
  if (raw === undefined || raw === "") return "";
  return String(raw).replace(/\/$/, "");
}

/** Absolute URL for an API path (must start with `/`). */
export function apiUrl(path: string): string {
  const p = path.startsWith("/") ? path : `/${path}`;
  return `${getApiBase()}${p}`;
}
